import resolveEnv, {
  CERT,
  DEV,
  DEV1,
  DEV2,
  IP,
  LOCAL,
  PRIOR,
  PROD,
  QA,
  QA1,
  QA2,
  STAGE,
  SUPPORT,
  TEST,
  TRAINING,
  UAT,
} from '@agentnet/utils';

// The host for most api calls, like get file info and search
export function getApiHost(): string {
  return `${environmentConfig.url}`;
}

//This url will be used only for document related APIs
//API Gateway has a limitation for Portal APIs
export function getAgencyApiHost(): string {
  return `${environmentConfig.agencyApiUrl}`;
}

//This url will be used for Property Reports and App switcher
export function getAgentNetMarketingUrl(route?: string): string {
  if (!route) {
    return `${environmentConfig.prismUrl}agentnet/account/signin`;
  }
  return `${environmentConfig.prismUrl}${route}/account/signin`;
}

//This url will be used only for AgentNet Knowledge Url
export function getAgentNetKnowledgeUrl(): string {
  return `${environmentConfig.agentNetKnowledgeUrl}`;
}

export function getContentfulSpaceId(): string {
  return environmentConfig.contentfulSpaceId;
}

export function getContentfulAccessToken(): string {
  return environmentConfig.contentfulAccessToken;
}

export function isContentfulPreview(): boolean {
  return environmentConfig.contentfulIsPreview;
}

export function isEnableAllFeatures(): boolean {
  return environmentConfig.enableAllFeatures ?? false;
}

export function getAnteUrl(): string {
  return environmentConfig.anteUrl ?? '';
}

export function getLaunchDarklyClientSideId(): string {
  return environmentConfig.launchDarklyClientSideId ?? '';
}

/**
 * Controls whether CSP violations are logged to browser console for developer visibility
 * - true: Log detailed violation info to console (all environments including PROD)
 * - false: Silent mode (disabled)
 * Note: Console logging is separate from backend reporting (which uses native browser CSP reporting)
 */
export function logCspViolationDetailsToConsole(): boolean {
  return environmentConfig.logCspViolationDetailsToConsole ?? true;
}

const config: {
  [env: string]: {
    url: string;
    agencyApiUrl: string; //Agency API Url for consuming document related APIs
    prismUrl: string; //Prism Client Url for Property Reports
    agentNetKnowledgeUrl: string; //AgentNet Knowledge Url
    contentfulSpaceId: string; //Contentful Space Id
    contentfulAccessToken: string; //Contentful Access Token for either Preview or Delivery
    contentfulIsPreview: boolean; //Flag for is preview is enabled for contentful queries
    enableAllFeatures?: boolean; //Release Feature Toggle  for Policy Upload, Underwriter, Report & Pay
    anteUrl?: string; //AgentNet 3.0 Url
    launchDarklyClientSideId?: string; //Launch Darkly Client Side Id,
    logCspViolationDetailsToConsole?: boolean; // Controls console logging for developer visibility
  };
} = {
  [LOCAL]: {
    url: 'https://env1.dev.services.agentnetportal.firstam.net/api/v1.0/',
    agencyApiUrl: 'https://env1.dev.agencyapi.firstam.net/',
    prismUrl: 'https://dev.prismpowered.com/',
    agentNetKnowledgeUrl: 'https://dev.knowledge.agentnet.firstam.com/auth/auto-signin',
    contentfulSpaceId: 'zvaayotzapxc',
    contentfulAccessToken: 'tNsgj4U8XEFkcoHdnt7akg-PF143452VdIZObLtEKTk',
    contentfulIsPreview: true,
    enableAllFeatures: true,
    anteUrl: 'https://dev1.agentnet.firstam.net/',
    launchDarklyClientSideId: '673be5b0deb09e088eef2ee6',
  },
  [DEV]: {
    url: 'https://dev.services.agentnetportal.firstam.net/api/v1.0/',
    agencyApiUrl: 'https://dev.agencyapi.firstam.net/',
    prismUrl: 'https://dev.prismpowered.com/',
    agentNetKnowledgeUrl: 'https://dev.knowledge.agentnet.firstam.com/auth/auto-signin',
    contentfulSpaceId: 'zvaayotzapxc',
    contentfulAccessToken: 'jvw2PsMv6HtTQn_tl4CxrmZ7R79n03SSbE40FBsTGlo',
    contentfulIsPreview: false,
    enableAllFeatures: true,
    anteUrl: 'https://dev.agentnet.firstam.net/',
  },
  [DEV1]: {
    url: 'https://env1.dev.services.agentnetportal.firstam.net/api/v1.0/',
    agencyApiUrl: 'https://env1.dev.agencyapi.firstam.net/',
    prismUrl: 'https://dev.prismpowered.com/',
    agentNetKnowledgeUrl: 'https://dev.knowledge.agentnet.firstam.com/auth/auto-signin',
    contentfulSpaceId: 'zvaayotzapxc',
    contentfulAccessToken: 'jvw2PsMv6HtTQn_tl4CxrmZ7R79n03SSbE40FBsTGlo',
    contentfulIsPreview: false,
    enableAllFeatures: true,
    anteUrl: 'https://dev1.agentnet.firstam.net/',
    launchDarklyClientSideId: '673be5b0deb09e088eef2ee6',
  },
  [DEV2]: {
    url: 'https://env2.dev.services.agentnetportal.firstam.net/api/v1.0/',
    agencyApiUrl: 'https://env2.dev.agencyapi.firstam.net/',
    prismUrl: 'https://dev.prismpowered.com/',
    agentNetKnowledgeUrl: 'https://dev.knowledge.agentnet.firstam.com/auth/auto-signin',
    contentfulSpaceId: 'zvaayotzapxc',
    contentfulAccessToken: 'jvw2PsMv6HtTQn_tl4CxrmZ7R79n03SSbE40FBsTGlo',
    contentfulIsPreview: false,
    enableAllFeatures: true,
    anteUrl: 'https://dev2.agentnet.firstam.net/',
    launchDarklyClientSideId: '673be60b6a1d310844325915',
  },
  [QA]: {
    url: 'https://qa.services.agentnetportal.firstam.net/api/v1.0/',
    agencyApiUrl: 'https://qa.agencyapi.firstam.net/',
    prismUrl: 'https://cert.prismpowered.com/',
    agentNetKnowledgeUrl: 'https://qa.knowledge.agentnet.firstam.com/auth/auto-signin',
    contentfulSpaceId: 'zvaayotzapxc',
    contentfulAccessToken: 'tNsgj4U8XEFkcoHdnt7akg-PF143452VdIZObLtEKTk',
    contentfulIsPreview: true,
    enableAllFeatures: true,
    anteUrl: 'https://qa.agentnet.firstam.net/',
  },
  [QA1]: {
    url: 'https://env1.qa.services.agentnetportal.firstam.net/api/v1.0/',
    agencyApiUrl: 'https://env1.qa.agencyapi.firstam.net/',
    prismUrl: 'https://cert.prismpowered.com/',
    agentNetKnowledgeUrl: 'https://qa.knowledge.agentnet.firstam.com/auth/auto-signin',
    contentfulSpaceId: 'zvaayotzapxc',
    contentfulAccessToken: 'tNsgj4U8XEFkcoHdnt7akg-PF143452VdIZObLtEKTk',
    contentfulIsPreview: true,
    enableAllFeatures: true,
    anteUrl: 'https://qa1.agentnet.firstam.net/',
    launchDarklyClientSideId: '673be5fc615a64081061fa2e',
  },
  [QA2]: {
    url: 'https://env2.qa.services.agentnetportal.firstam.net/api/v1.0/',
    agencyApiUrl: 'https://env2.qa.agencyapi.firstam.net/',
    prismUrl: 'https://cert.prismpowered.com/',
    agentNetKnowledgeUrl: 'https://qa.knowledge.agentnet.firstam.com/auth/auto-signin',
    contentfulSpaceId: 'zvaayotzapxc',
    contentfulAccessToken: 'tNsgj4U8XEFkcoHdnt7akg-PF143452VdIZObLtEKTk',
    contentfulIsPreview: true,
    enableAllFeatures: true,
    anteUrl: 'https://qa2.agentnet.firstam.net/',
    launchDarklyClientSideId: '673be605beaa24088a1b9b36',
  },
  [TEST]: {
    url: 'https://test.services.agentnetportal.firstam.net/api/v1.0/',
    agencyApiUrl: 'https://test.agencyapi.firstam.net/',
    prismUrl: 'https://cert.prismpowered.com/',
    agentNetKnowledgeUrl: 'https://uat.knowledge.agentnet.firstam.com/auth/auto-signin',
    contentfulSpaceId: 'zvaayotzapxc',
    contentfulAccessToken: 'jvw2PsMv6HtTQn_tl4CxrmZ7R79n03SSbE40FBsTGlo',
    contentfulIsPreview: false,
    enableAllFeatures: false,
    // anteUrl: 'https://qa2.agentnet.firstam.com/',
  },
  [UAT]: {
    url: 'https://uat.services.agentnetportal.firstam.net/api/v1.0/',
    agencyApiUrl: 'https://uat.agencyapi.firstam.net/',
    prismUrl: 'https://cert.prismpowered.com/',
    agentNetKnowledgeUrl: 'https://uat.knowledge.agentnet.firstam.com/auth/auto-signin',
    contentfulSpaceId: 'zvaayotzapxc',
    contentfulAccessToken: 'jvw2PsMv6HtTQn_tl4CxrmZ7R79n03SSbE40FBsTGlo',
    contentfulIsPreview: false,
    enableAllFeatures: false,
    anteUrl: 'https://uat.agentnet.firstam.com/',
  },
  [CERT]: {
    url: 'https://cert.services.agentnetportal.firstam.net/api/v1.0/',
    agencyApiUrl: 'https://cert.agencyapi.firstam.net/',
    prismUrl: 'https://cert.prismpowered.com/',
    agentNetKnowledgeUrl: 'https://uat.knowledge.agentnet.firstam.com/auth/auto-signin',
    contentfulSpaceId: 'zvaayotzapxc',
    contentfulAccessToken: 'jvw2PsMv6HtTQn_tl4CxrmZ7R79n03SSbE40FBsTGlo',
    contentfulIsPreview: false,
    enableAllFeatures: true,
    anteUrl: 'https://cert.agentnet.firstam.com/',
    launchDarklyClientSideId: '6806873f20748e08a73fae2b',
  },
  [IP]: {
    url: 'https://api.agentnetstage.firstam.com/agentnet-service/api/v1.0/',
    agencyApiUrl: 'https://ip.agencyapi.firstam.com/',
    prismUrl: 'https://cert.prismpowered.com/',
    agentNetKnowledgeUrl: 'https://uat.knowledge.agentnet.firstam.com/auth/auto-signin',
    contentfulSpaceId: 'zvaayotzapxc',
    contentfulAccessToken: 'jvw2PsMv6HtTQn_tl4CxrmZ7R79n03SSbE40FBsTGlo',
    contentfulIsPreview: false,
    enableAllFeatures: false,
    anteUrl: 'https://ip.agentnet.firstam.com/',
    launchDarklyClientSideId: '673be6111d3d5e085676f392',
  },
  [SUPPORT]: {
    url: 'https://support.services.agentnetportal.firstam.net/api/v1.0/',
    agencyApiUrl: 'https://support.agencyapi.firstam.net/',
    prismUrl: 'https://cert.prismpowered.com/',
    agentNetKnowledgeUrl: 'https://uat.knowledge.agentnet.firstam.com/auth/auto-signin',
    contentfulSpaceId: 'zvaayotzapxc',
    contentfulAccessToken: 'jvw2PsMv6HtTQn_tl4CxrmZ7R79n03SSbE40FBsTGlo',
    contentfulIsPreview: false,
    enableAllFeatures: true,
    anteUrl: 'https://support.agentnet.firstam.net/',
    launchDarklyClientSideId: '6806868eb18aa908e198a99c',
  },
  [STAGE]: {
    url: 'https://stage.services.agentnetportal.firstam.net/api/v1.0/',
    agencyApiUrl: 'https://stage.agencyapi.firstam.net/',
    prismUrl: 'https://cert.prismpowered.com/',
    agentNetKnowledgeUrl: 'https://uat.knowledge.agentnet.firstam.com/auth/auto-signin',
    contentfulSpaceId: 'zvaayotzapxc',
    contentfulAccessToken: 'jvw2PsMv6HtTQn_tl4CxrmZ7R79n03SSbE40FBsTGlo',
    contentfulIsPreview: false,
    enableAllFeatures: true,
    anteUrl: 'https://stage.agentnet.firstam.net/',
    launchDarklyClientSideId: '6806863220748e08a73fa0b1',
  },
  [TRAINING]: {
    url: 'https://api.agentnetstage.firstam.com/agentnet-service-training/api/v1.0/',
    agencyApiUrl: 'https://training.agencyapi.firstam.com/',
    prismUrl: 'https://cert.prismpowered.com/',
    agentNetKnowledgeUrl: 'https://uat.knowledge.agentnet.firstam.com/auth/auto-signin',
    contentfulSpaceId: 'zvaayotzapxc',
    contentfulAccessToken: 'jvw2PsMv6HtTQn_tl4CxrmZ7R79n03SSbE40FBsTGlo',
    contentfulIsPreview: false,
    enableAllFeatures: true,
    anteUrl: 'https://training.agentnet.firstam.com/',
    launchDarklyClientSideId: '68068601da547c093dfed947',
  },
  [PRIOR]: {
    url: 'https://prior.services.agentnetportal.firstam.net/api/v1.0/',
    agencyApiUrl: 'https://prior.agencyapi.firstam.net/',
    prismUrl: 'https://cert.prismpowered.com/',
    agentNetKnowledgeUrl: 'https://uat.knowledge.agentnet.firstam.com/auth/auto-signin',
    contentfulSpaceId: 'zvaayotzapxc',
    contentfulAccessToken: 'jvw2PsMv6HtTQn_tl4CxrmZ7R79n03SSbE40FBsTGlo',
    contentfulIsPreview: false,
    enableAllFeatures: true,
    anteUrl: 'https://prior.agentnet.firstam.net/',
    launchDarklyClientSideId: '6806864442dea508d71f34ff',
  },
  [PROD]: {
    url: 'https://api.agentnet.firstam.com/agentnet-service/api/v1.0/',
    agencyApiUrl: 'https://agencyapi.firstam.com/',
    prismUrl: 'https://prismpowered.com/',
    agentNetKnowledgeUrl: 'https://knowledge.agentnet.firstam.com/auth/auto-signin',
    contentfulSpaceId: 'zvaayotzapxc',
    contentfulAccessToken: 'jvw2PsMv6HtTQn_tl4CxrmZ7R79n03SSbE40FBsTGlo',
    contentfulIsPreview: false,
    enableAllFeatures: false,
    anteUrl: 'https://agency.myfirstam.com/',
    launchDarklyClientSideId: '673be55506c5ad0839259be7',
  },
};

const environmentConfig = config[resolveEnv()];
